module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Slot/images/slot-50.a332f80d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Slot/images/slot-50.png
// module id = 3364
// module chunks = 11